import { createModalStore } from '@/shared/lib/modal';

export const useUnsavedChangesGlossaryModalStore = createModalStore();
